import {Question} from '../shared/question';
import {Response} from '../shared/response';

export class WinstonWave2Survey{

    question1:Question;
    question2:Question;
    question3:Question;
    question4:Question;
    question5:Question;
    question6:Question;
    question7:Question;
    question8:Question;
    question9:Question;
    question10:Question;
    question11:Question;
    question12:Question;

    questions: Array<Question>;


    constructor(){
        this.question1 = new Question(1, [], 
            'In ultimii 2 ani, la cate campanii pentru adultii fumatori de pe site-ul yourfreedom.ro ai introdus coduri din pachetele de tigarete? Bifeaza varianta care se aplica.',
            'Campanie = perioada de 4-5 luni in care puteai introduce coduri din anumite pachete de tigarete pe site-ul yourfreedom.ro si aveai sansa de a castiga anumite premii',
            'radio',
            [new Response(1, '1 campanie'), 
            new Response(2, '2 campanii'), 
            new Response(3, '3 campanii'), 
            new Response(4, '4 campanii sau mai multe'),
            new Response(5, 'Am intrat pe site, dar nu am introdus coduri')
            ],
            false
        );
        
        this.question2 = new Question(2, [1],
            'Ai intrat pe site-ul yourfreedom.ro si la ultima campanie desfasurata: cea din perioada 26 iunie – 02 octombrie? Bifeaza varianta care se aplica.',
            '',
            'radio',
            [new Response(1, 'Da si am introdus coduri'), 
            new Response(2, 'Da, dar nu am introdus coduri'), 
            new Response(3, 'Nu am intrat pe site-ul yourfreedom.ro la ultima campanie')
            ],
            false
        );
    
        this.question2.render = ()=>{
            let question1SelectedIds = this.getSelectedAnswersIds(this.question1);
            return question1SelectedIds.length> 0 && question1SelectedIds.indexOf(5) < 0;
        }

        this.question3 = new Question(3, [1],
            'Ai intrat pe site-ul yourfreedom.ro la ultima campanie din perioada: cea din perioada 26 iunie – 02 octombrie? Bifeaza varianta care se aplica.',
            '',
            'radio',
            [new Response(1, 'Da'), 
            new Response(2, 'Nu'),
            ],
            false
        );
        this.question3.render = ()=>{
            let question1SelectedIds = this.getSelectedAnswersIds(this.question1);
            return question1SelectedIds.length> 0 && question1SelectedIds.indexOf(5) >= 0;
        }

        this.question4 = new Question(4, [2, 3],
            'De unde ai aflat de ultima campanie pentru adultii fumatori de pe yourfreedom.ro?',
            'Selecteaza toate raspunsurile care se aplica. In plus, poti mentiona si altceva, daca nu se regaseste in lista',
            'checkbox-free',
            [new Response(1, 'De pe un site unde sunt prezentate diverse promotii pentru adultii fumatori'),
            new Response(2, 'Am auzit de la un alt adult fumator: din familie/ prieten/ cunostinta/ coleg'),
            new Response(3, 'De la vanzatoarea/ul din magazinul de unde imi iau tigarete'),
            new Response(4, 'Am vazut o reclama intr-un magazin care vinde tigarete'),
            new Response(5, 'Am primit un email/ SMS/ notificare in aplicatie'),
            new Response(6, 'Am primit invitatie/ un link de la un alt adult fumator'),
            new Response(7, 'Festivaluri de muzica (Untold, Neversea, SAGA etc)'),
            new Response(8, 'Din alta parte'),
            ],
            true
        );
        this.question4.render = ()=>{
            return this.isParticipant();
        }

        this.question5 = new Question(5, [2,3],
            'Pe care dintre următoarele tipuri de premii le-ai văzut pe site-ul yourfreedom.ro la ultima campanie? ',
            'Alege toate tipurile de premii de care ai auzit, indiferent dacă le-ai câștigat sau nu, sau dacă ai ales sa introduci coduri special pentru castigarea acestora:',
            'checkbox',
            [new Response(1, 'Premii mari (strangi 20 minute de libertate si ai sanse la un premiu in bani) '), 
            new Response(2, 'Premii saptamanale (strangi 10 minute de libertate si ai sansa la un premiu in obiecte)'), 
            new Response(3, 'Premii de popularitate (invitatii pe site pentru prietenii adulti fumatori)'), 
            new Response(4, 'Premii instant (orice cod inscris poate fi castigator)'),
            new Response(5, 'Premii de Freedom Days (zile cu premii speciale)'),
            ],
            false
        );
        this.question5.render = ()=>{
            return this.isParticipant();
        }

        this.question6 = new Question(6, [2,3,5],
            'Ordonează fiecare dintre aceste premii de la cel care îți place cel mai mult (locul 1), la cel care îți place cel mai puțin (ultimul loc).',
            'Dacă nu ai ales sa introduci coduri special pentru a castiga vreunul dintre ele, ordonează-le după descrierea modului de participare/ a premiului oferit.',
            'order',
            [new Response(1, 'Premii mari (strangi 20 minute de libertate si ai sanse la un premiu in bani)'),
            new Response(2, 'Premii saptamanale (strangi 10 minute de libertate si ai sansa la un premiu in obiecte)'),
            new Response(3, 'Premii de popularitate (invitatii pe site pentru preietenii adulti fumatori)'),
            new Response(4, 'Premii instant (orice cod inscris poate fi castigator)'),
            new Response(5, 'Premii de Freedom Days (zile cu premii speciale)')
            ],
            false
        );
        let question6ResponseRenderer = (rsp:Response):boolean=>{
            let question5SelectedIds = this.getSelectedAnswersIds(this.question5);
            return question5SelectedIds.indexOf(rsp.id) >= 0;
        }
        this.question6.responses[0].render=question6ResponseRenderer;
        this.question6.responses[1].render=question6ResponseRenderer;
        this.question6.responses[2].render=question6ResponseRenderer;
        this.question6.responses[3].render=question6ResponseRenderer;
        this.question6.responses[4].render=question6ResponseRenderer;
        this.question6.render = ()=>{
            return this.question5.responses.filter(r => r.selected).length > 1 && this.isParticipant();
        }

        this.question7 = new Question(7, [2,3,5],
            'Ce suma de bani stii sa fi fost la premiul cel mare la ultima campanie, desfasurata de la sfarsitul lui iunie pana la inceput de octombrie? Bifeaza varianta care se aplica.',
            '',
            'radio',
            [new Response(1, 'Mai putin de 10,000 EUR'), 
            new Response(2, '10,000 EUR'), 
            new Response(3, '20.000 EUR'), 
            new Response(4, '30.000 EUR'),
            new Response(5, '40.000 EUR'),
            new Response(6, '50.000 EUR'),
            new Response(7, 'Mai mult de 50,000 EUR'),
            new Response(8, 'Nu au fost bani la premiul cel mare')
            ],
            false
        );
        this.question7.render = ()=>{
            return this.question5.responses.filter(rsp=>rsp.id === 1)[0].selected && this.isParticipant();
        }

        this.question8 = new Question(8, [1, 2, 3, 5],
            'Gandindu-te la alte campanii de pe site-ul yourfreedom.ro (inainte de iunie anul acesta), pentru adulti fumatori, premiile mari de la ultima campanie ti s-au parut:',
            '',
            'radio',
            [new Response(1, 'De o valoare mai mica decat in alte campanii'), 
            new Response(2, 'De aceeasi valoare ca in alte campanii'), 
            new Response(3, 'De o valoare mai mare decat in alte campanii'), 
            ],
            false
        );
        this.question8.render = ()=>{
            let question1SelectedIds = this.getSelectedAnswersIds(this.question1);
            let enteredMultipleCampaigns = question1SelectedIds.indexOf(5) < 0 && question1SelectedIds.indexOf(1) < 0;
            let selectedBigPrizes = this.question5.responses.filter(rsp=>rsp.id === 1)[0].selected;
            return enteredMultipleCampaigns && selectedBigPrizes && this.isParticipant();
        }

        this.question9 = new Question(9, [1,2],
            'La ultima campanie (sfarsit de iunie – inceput de octombrie) ai introdus:',
            'Bifeaza varianta care se aplica.',
            'radio',
            [new Response(1, 'Mai multe coduri decat in alte campanii la care ai participat pe yourfreedom.ro'), 
            new Response(2, 'Un numar aproape egal sau egal de coduri ca in alte campanii la care ai participat pe yourfreedom.ro'), 
            new Response(3, 'Mai putine coduri decat in alte campanii la care ai participat pe yourfreedom.ro'), 
            ],
            false
        );
        this.question9.render = ()=>{
            let question1SelectedIds = this.getSelectedAnswersIds(this.question1);
            let enteredMultipleCampaigns = question1SelectedIds.indexOf(5) < 0 && question1SelectedIds.indexOf(1) < 0;
            return enteredMultipleCampaigns && this.question2.render() && 
                this.question2.responses.filter(rsp=>rsp.id === 1)[0].selected ;
        }





        this.question10 = new Question(10, [2,3,9], 
            'Care sunt motivele pentru care ai introdus mai putine coduri in aceasta campanie?',
            'Selecteaza toate raspunsurile care se aplica. In plus, poti mentiona si altceva, daca nu se regaseste in lista',
            'checkbox-free',
            [new Response(1, 'Premiile nu m-au atras'), 
            new Response(2, 'Nu (mai) fumez atat de des variantele de Winston care aveau coduri participante la promotia pentru adultii fumatori'), 
            new Response(3, 'Am fost plecat(a)/ ocupat(a) in perioada campaniei (vacante/ evenimente etc)'), 
            new Response(4, 'Site-ul a mers greu si am intrat mai rar'), 
            new Response(5, 'Mai luam coduri si de la alti adulti fumatori si acum nu am mai avut acces la ele'), 
            new Response(6, 'Alt motiv')
            ],
            true
        );
        this.question10.render = ()=>{
            let question9SelectedIds = this.getSelectedAnswersIds(this.question9);;
            return question9SelectedIds.indexOf(3) >= 0 && this.isParticipant();
        }

        this.question11 = new Question(11, [2], 
            'Care sunt motivele pentru care nu ai introdus coduri in aceasta campanie?',
            'Selecteaza toate raspunsurile care se aplica. In plus, poti mentiona si altceva, daca nu se regaseste in lista',
            'checkbox-free',
            [new Response(1, 'Premiile nu m-au atras'), 
            new Response(2, 'Am schimbat marca de tigari pe care o fumez cel mai des'),
            new Response(3, 'Nu (mai) fumez atat de des variantele de Winston care aveau coduri participante la promotia pentru adultii fumatori'), 
            new Response(4, 'Am fost plecat(a)/ ocupat(a) in perioada campaniei (vacante/ evenimente etc)'), 
            new Response(5, 'Site-ul a mers greu si am intrat mai rar'), 
            new Response(6, 'Luam codurile de la alti adulti fumatori si acum nu am mai avut acces la ele'), 
            new Response(7, 'Nu am inteles cum pot participa/ castiga premiile'),
            new Response(8, 'Nu am inteles/stiut ce premii pot castiga'),
            new Response(9, 'Alt motiv')
            ],
            true
        );
        this.question11.render = ()=>{
            return this.question2.render() && this.question2.responses.filter(rsp=>rsp.id === 2)[0].selected ;
        }

        this.question12 = new Question(12, [2,3], 
            'Care sunt motivele pentru care nu ai participat la ultima campanie?',
            'Selecteaza toate raspunsurile care se aplica. In plus, poti mentiona si altceva, daca nu se regaseste in lista',
            'checkbox-free',
            [new Response(1, 'Premiile nu m-au atras'), 
            new Response(2, 'Nu am stiut ca a fost campanie in perioada sfarsit de iunie – inceput de octombrie'),
            new Response(3, 'Nu fumez marca Winston'), 
            new Response(4, 'Nu fumez variantele de Winston care aveau coduri participante la promotia pentru adultii fumatori'), 
            new Response(5, 'Am fost plecat(a)/ ocupat(a) in perioada campaniei (vacante/ evenimente etc)'), 
            new Response(6, 'Site-ul a mers greu si am intrat mai rar'), 
            new Response(7, 'Luam codurile de la alti adulti fumatori si acum nu am mai avut acces la ele'), 
            new Response(8, 'Nu am inteles cum pot participa/ castiga premiile'),
            new Response(9, 'Nu am inteles/stiut ce premii pot castiga'),
            new Response(10, 'Alt motiv')
            ],
            true
        );
        this.question12.render = ()=>{
            if(this.question2.render()){
                let selected = this.getSelectedAnswersIds(this.question2);
                return selected.length > 0 && selected.indexOf(3) >= 0;
            }else if(this.question3.render()){
                let selected = this.getSelectedAnswersIds(this.question3);
                return selected.length > 0 && selected.indexOf(2) >= 0;
            }else{
                return false;
            }
        }

        this.questions = [this.question1, this.question2, this.question3, this.question4, this.question5, this.question6, this.question7, this.question8,
            this.question9, this.question10, this.question11, this.question12];
    }

    
    getQuestions():Array<Question>{
        return this.questions;
    }

    getSelectedAnswersIds(question:Question):Array<Number>{
        return question.responses.filter(r => r.selected).map(r => r.id);
    } 

    isParticipant(): boolean{
        if(this.question2.render()){
            let selected = this.getSelectedAnswersIds(this.question2);
            return selected.length > 0 && selected.indexOf(3) < 0;
        }else if(this.question3.render()){
            let selected = this.getSelectedAnswersIds(this.question3);
            return selected.length > 0 && selected.indexOf(2) < 0;
        }else{
            return false;
        }
    }
    
}

